<template>
  <div class="personal-r">
    <h2>点卡充值</h2>
    <div class="dkts-step1" v-show="step === 1">
      <p class="prompt">
        <span>提示：</span>点卡密码为20位数字，输入时请注意！
        <span>咨询电话：</span>021-20219997
      </p>
      <div class="card clearfix">
        <span>点卡密码：</span>
        <div class="input-group" ref="inputGroup">
          <span>
            <input type="text" maxlength="4" v-model="key1" @keyup="nextFocus($event,0)" />
          </span>
          <span>
            <input type="text" maxlength="4" v-model="key2" @keyup="nextFocus($event,1)" />
          </span>
          <span>
            <input type="text" maxlength="4" v-model="key3" @keyup="nextFocus($event,2)" />
          </span>
          <span>
            <input type="text" maxlength="4" v-model="key4" @keyup="nextFocus($event,3)" />
          </span>
          <span>
            <input type="text" maxlength="4" v-model="key5" />
          </span>
        </div>
        <span class="btn" @click="getCard">下一步</span>
      </div>
      <!-- 购买协议组件 -->
      <div class="license">
        <h3 class="title">
          <span>
            <router-link to="/protocol" target="_blank">使用软件产品许可协议</router-link>
          </span>
          <p>
            <i
              class="icon-right"
              @click="cancelActive = !cancelActive"
              :class="{cancel:cancelActive}"
            ></i>我已仔细阅读相关协议，对其内容表示确认
          </p>
        </h3>
      </div>
    </div>
    <div class="dkts-step2" v-show="step === 2">
      <div>
        <p>
          点卡号码：
          <span>{{card.id}}</span>
        </p>
        <p>
          对应产品：
          <span>{{card.productName}}</span>
        </p>
        <p>
          使用期限：
          <span>{{card.monthCount}}个月</span>
        </p>
      </div>
      <span class="btn" @click="step = 1">上一步</span>
      <span class="btn" @click="activeCard">激活账号</span>
    </div>
    <div class="dkts-step2" v-show="step === 3">
      <p>
        <span>账号激活完毕！</span>咨询电话：021-20219997
      </p>
      <div>
        <p>
          点卡号码：
          <span>{{card.id}}</span>
        </p>
        <p>
          对应产品：
          <span>{{card.productName}}</span>
        </p>
        <p>
          使用期限：
          <span>{{card.monthCount}}个月</span>
        </p>
        <p>
          订单号：
          <span>{{card.paymentId}}</span>
        </p>
      </div>
      <span class="btn" @click="step = 1">返回</span>
    </div>
  </div>
</template>
<script>
import Protocol from "@/components/protocol/Protocol.vue";
export default {
  name: "CardPay",
  data() {
    return {
      key: "",
      key1: "",
      key2: "",
      key3: "",
      key4: "",
      key5: "",
      card: {},
      cancelActive: false,
      step: 1
    };
  },
  mounted: function() {},
  methods: {
    nextFocus(e, index) {
      var dom = document.getElementsByTagName("input"),
        currInput = dom[index],
        nextInput = dom[index + 1];
      if (currInput.value && currInput.value.length == 4) {
        nextInput.focus();
      }
    },
    getCard() {
      if (this.cancelActive) {
        this.$alert(
          "请仔细阅读“上海大智慧信息科技有限公司软件产品许可使用协议”，阅读结束后同意请选中“我同意协议”钩选框，然后继续购买。",
          "提示",
          {
            confirmButtonText: "确定"
          }
        );
        return false;
      }
      if (
        this.key1.length != 4 ||
        this.key2.length != 4 ||
        this.key3.length != 4 ||
        this.key4.length != 4 ||
        this.key5.length != 4
      ) {
        this.$alert("请输入完整的点卡密码。", "提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      this.key = this.key1 + this.key2 + this.key3 + this.key4 + this.key5;
      this.$get("/card/get?secretKey=" + this.key)
        .then(response => {
          if (response.code === 0) {
            this.card = response.data;
            this.step = 2;
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    activeCard() {
      this.$get("/card/active?secretKey=" + this.key)
        .then(response => {
          if (response.code === 0) {
            this.card = response.data;
            this.step = 3;
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    }
  },
  components: {
    Protocol
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/scss/personal.scss";
.dkts-step1 {
  padding-top: 35px;
  .prompt {
    @include fc(20px, #222);
    text-align: center;
    span {
      color: #666;
      margin-left: 20px;
    }
  }
  .card {
    padding: 45px 0 45px 110px;
    span {
      @include fc(20px, #222);
      float: left;
    }
    .btn {
      @include vertical-center(164px, 52px);
      color: #fff;
      border-radius: 6px;
      margin-top: -14px;
    }
    .input-group {
      float: left;
      span {
        &:last-child {
          &:after {
            display: none;
          }
        }
        &:after {
          content: "";
          display: inline-block;
          @include wh(14px, 1px);
          background: #979797;
          margin: 0 10px;
          vertical-align: middle;
        }
      }
      input {
        @include vertical-center(54px, 36px);
        border: 1px solid #c8c8c8;
        box-sizing: border-box;
        @include fc(20px, #222);
      }
    }
  }
  .license h3 > span {
    font-size: 20px;
  }
}
.dkts-step2 {
  padding: 50px 0 0 90px;
  p {
    @include fc(20px, #101010);
    span {
      color: #ef3939;
    }
  }
  > div {
    margin-top: 22px;
    padding: 25px 0 15px 35px;
    width: 516px;
    box-sizing: border-box;
    border: 1px solid #d6d6d6;
    p {
      margin-bottom: 10px;
    }
  }
  .btn {
    margin-top: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/CardPay.vue